import { Tabs as ChakraTabs, chakra } from '@chakra-ui/react';

export const Tabs = chakra(ChakraTabs, { baseStyle: {} });
